/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import Carousel from './Carousel'

function CoverflowCirclePreview({ srcs, redirectUrl }) {
  const [key, setKey] = useState(0)
  const [angle, setAngle] = useState(0)
  const [scrollDistance, setScroll] = useState(0)
  const [visible, setVisible] = useState(true)
  const wheelLockRef = useRef(false)

  const validImages = srcs.filter(
    (src) =>
      src.file instanceof Blob ||
      src.file instanceof File ||
      (typeof src.file === 'string' && src.file.startsWith('blob:'))
  )

  useEffect(() => {
    if (srcs.length > 0) setKey((prev) => prev + 1)
  }, [srcs.length])

  const handleWheel = (e) => {
    if (wheelLockRef.current) return

    setScroll((prev) => prev + Math.abs(e.deltaY))
    if (scrollDistance >= 70) {
      wheelLockRef.current = true
      const rotation = e.deltaY > 0 ? 90 : -90
      setAngle((prev) => prev + rotation)
      setScroll(0)
      setTimeout(() => {
        wheelLockRef.current = false
      }, 300)
    }
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
      onWheel={handleWheel}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
      </div>

      {visible && (
        <div
          role="presentation"
          style={{
            position: 'absolute',
            bottom: '18%',
            right: '23.5%',
            cursor: 'pointer',
          }}
          onClick={() => {
            if (redirectUrl) window.open(redirectUrl, '_blank')
          }}
        >
          <button
            type="button"
            aria-label="close carousel"
            onClick={(e) => {
              e.stopPropagation()
              setVisible(false)
            }}
            style={{
              position: 'absolute',
              top: '-45px',
              right: '-45px',
              zIndex: 20,
              border: 'none',
              background: 'rgba(0,0,0,0.6)',
              color: '#fff',
              width: '22px',
              height: '22px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <FontAwesomeIcon icon={faXmark} size="sm" />
          </button>

          <Carousel key={key} validImages={validImages} angle={angle} />
        </div>
      )}

      <div style={{ position: 'relative' }}>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

CoverflowCirclePreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
        PropTypes.string,
      ]),
      label: PropTypes.string,
    })
  ).isRequired,
  redirectUrl: PropTypes.string,
}

CoverflowCirclePreview.defaultProps = {
  redirectUrl: '',
}

export default CoverflowCirclePreview
